export interface Branch {
  id: number;
  name: {
    ar: string;
    en: string;
  };
  address: {
    ar: string;
    en: string;
  };
  phone: string;
  whatsapp: string;
  coordinates: {
    lat: number;
    lng: number;
  };
  hours: {
    ar: string;
    en: string;
  };
}

export const branches: Branch[] = [
  {
    id: 1,
    name: {
      ar: 'فرع المحلة الكبرى (الفرع الرئيسي)',
      en: 'El-Mahalla El-Kubra Branch (Main Branch)',
    },
    address: {
      ar: 'شارع 23 يوليو (شارع البحر سابقاً)، عمارة بركات، بجوار سينما المحلة، مدينة المحلة الكبرى، محافظة الغربية، مصر',
      en: '23 July Street (formerly Sea Street), Barakat Building, next to El-Mahalla Cinema, El-Mahalla El-Kubra City, Gharbia Governorate, Egypt',
    },
    phone: '+20 100 607 6325',
    whatsapp: '+20 105 054 5050',
    coordinates: {
      lat: 30.9700,
      lng: 31.1667,
    },
    hours: {
      ar: 'من 8 صباحاً إلى 10 مساءً',
      en: '8 AM to 10 PM',
    },
  },
  {
    id: 2,
    name: {
      ar: 'فرع طلعت حرب – المحلة الكبرى',
      en: 'Talaat Harb Branch – El-Mahalla El-Kubra',
    },
    address: {
      ar: 'برج دار الطب أمام موقف طلعت حرب',
      en: 'Dar Al-Tibb Tower, in front of Talaat Harb Station',
    },
    phone: '+20 XXX XXX XXXX',
    whatsapp: '+20 105 054 5050',
    coordinates: {
      lat: 30.9700,
      lng: 31.1667,
    },
    hours: {
      ar: 'من 8 صباحاً إلى 10 مساءً',
      en: '8 AM to 10 PM',
    },
  },
  {
    id: 3,
    name: {
      ar: 'فرع الراهبين',
      en: 'El-Rahabeen Branch',
    },
    address: {
      ar: 'الطريق الزراعي – موقف الأوتوبيس',
      en: 'Agricultural Road – Bus Station',
    },
    phone: '+20 XXX XXX XXXX',
    whatsapp: '+20 105 054 5050',
    coordinates: {
      lat: 30.9700,
      lng: 31.1667,
    },
    hours: {
      ar: 'من 8 صباحاً إلى 10 مساءً',
      en: '8 AM to 10 PM',
    },
  },
];

